"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVITATION_STATUS_TABS = exports.INVITATION_STATUS_LABELS = void 0;
var INVITATION_STATUS_TABS = [
    { label: "All", value: "ALL" },
    { label: "Sent", value: "SENT" },
    { label: "Accepted", value: "ACCEPTED" },
    { label: "Cancelled", value: "CANCELLED" },
];
exports.INVITATION_STATUS_TABS = INVITATION_STATUS_TABS;
var INVITATION_STATUS_LABELS = {
    SENT: "Sent",
    ACCEPTED: "Accepted",
    CANCELLED: "Cancelled",
};
exports.INVITATION_STATUS_LABELS = INVITATION_STATUS_LABELS;
